import locationData from "./data/locations.v1.json";
import nrcData from "./data/nrcTownships.v1.json";

export type SelectOption = {
  value: string;
  label: string;
  searchText?: string;
};

export const NRC_STATES = nrcData.states;
export const LOCATION_REGIONS = locationData.regions;

export function getNrcTownships(stateCode: string) {
  return nrcData.townships.filter((township) => township.stateCode === stateCode);
}

export function toMyanmarDigits(value: string): string {
  const digits = "၀၁၂၃၄၅၆၇၈၉";
  return value.replace(/[0-9]/g, (digit) => digits[Number(digit)]);
}

const NRC_CODE_SYLLABLES = [
  "KHA", "PHA", "HTA", "THA", "NYA", "NGA", "HSA",
  "AH", "OU", "AU", "BA", "GA", "DA", "HA", "KA", "LA", "MA",
  "NA", "PA", "RA", "SA", "TA", "YA", "WA", "ZA"
] as const;

export function formatNrcTownshipCode(code: string): string {
  let remaining = code.toUpperCase();
  const parts: string[] = [];
  while (remaining) {
    const syllable = NRC_CODE_SYLLABLES.find((candidate) => remaining.startsWith(candidate));
    if (!syllable) return code;
    parts.push(`${syllable[0]}${syllable.slice(1).toLowerCase()}`);
    remaining = remaining.slice(syllable.length);
  }
  return parts.join("");
}

export function resetNrcTownshipForState(stateCode: string, townshipCode: string): string {
  return getNrcTownships(stateCode).some((township) => township.code === townshipCode)
    ? townshipCode
    : "";
}

export function sanitizeNrcDigits(value: string): string {
  return value.replace(/[^0-9]/g, "").slice(0, 6);
}

export function isValidNrcDigits(value: string): boolean {
  return /^[0-9]{6}$/.test(value);
}

export function getLocationTownships(regionCode: string) {
  return locationData.townships.filter((township) => township.regionCode === regionCode);
}

export function regionOptions(): SelectOption[] {
  return LOCATION_REGIONS.map((region) => ({
    value: region.code,
    label: `${region.nameMm} / ${region.nameEn}`,
    searchText: `${region.nameMm} ${region.nameEn} ${region.code}`
  }));
}

export function townshipOptions(regionCode: string): SelectOption[] {
  return getLocationTownships(regionCode).map((township) => ({
    value: township.code,
    label: `${township.nameMm} / ${township.nameEn}`,
    searchText: `${township.nameMm} ${township.nameEn} ${township.code}`
  }));
}

export const DATASET_NOTES = {
  nrc: nrcData.meta,
  locations: locationData.meta
};
